import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as NotebookActions from './notebook.actions';
import { NotebookClientService } from '@mode/notebooks/data-access';
@Injectable()
export class NotebookEffects {
  createNotebook$ = createEffect(() =>
    this.actions$.pipe(
      ofType(NotebookActions.createNotebook),
      mergeMap((action) =>
        this.notebookService.createNotebook(action.reportToken).pipe(
          map((res) => {
            return NotebookActions.addNotebookResourcesOnSuccess({ notebookResource: res });
          }),
          catchError((error) => of(NotebookActions.addNotebookFailure({ reportToken: action.reportToken, error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private notebookService: NotebookClientService
  ) {}
}
